/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import { AnyAction } from 'redux';

import { Channel } from '../../../core/entities/Channel';
import { GuideType } from '../../../core/enums';
import {
    SET_CHANNEL_OPTIONS,
    SET_CHANNEL_OPTIONS_OVERLAY_CONTEXT,
    SET_CHANNELS_TYPE,
} from './channeloptionsoverlay.types';

export const setChannelsTypeAction = (
    channelsType: string,
    channelsTypeIndex: string,
): AnyAction => ({
    type: SET_CHANNELS_TYPE,
    payload: {
        channelsType,
        channelsTypeIndex,
    },
});

export const setChannelOptionsAction = (
    channelsType: string,
    watchNowText: string,
    channelsText: string,
    horizontalSelectionOptions: string[],
): AnyAction => ({
    type: SET_CHANNEL_OPTIONS,
    payload: {
        channelsType,
        watchNowText,
        channelsText,
        horizontalSelectionOptions,
    },
});

export const setChannelOptionsOverlayContextAction = (
    channel: Channel,
    guideType: GuideType,
): AnyAction => ({
    type: SET_CHANNEL_OPTIONS_OVERLAY_CONTEXT,
    payload: {
        channel,
        guideType,
    },
});
